
function NotFound() {
    return (
        <div className={"container mx-auto mt-16"}>
            <h2 className={"mx-auto text-center font-roboto text-5xl font-semibold"}>Not found</h2>
            <p className={"mx-auto text-center font-roboto text-3xl mt-8"}>There is no such characters in Rick&Morty :(</p>
        </div>
    )
}

export default NotFound;
